export default function LineClose() {
    return (
        <svg width="11" height="4" viewBox="0 0 11 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.688292 3.475V0.975H10.6883V3.475H0.688292Z" fill="#61B22C"/>
</svg>


    )
}